module.exports = __webpack_public_path__ + "static/media/S2N7-3.9826a99f.svg";